export default function CentroDetail({ centro }) {
  if (!centro) {
    return (
      <div className="rounded-2xl border border-dashed border-[rgb(var(--border))] bg-[rgba(var(--panel),0.4)] p-6 text-center text-sm text-[rgb(var(--muted))]">
        Seleccioná un centro para ver la información.
      </div>
    );
  }

  return (
    <section className="rounded-2xl border border-[rgb(var(--border))] bg-[rgba(var(--panel),0.92)] p-6 shadow-[0_20px_36px_-24px_rgba(var(--shadow),0.4)]">
      <header className="flex flex-col gap-1">
        <span className="text-xs uppercase tracking-wider text-[rgb(var(--muted))]">Centro de costo</span>
        <h2 className="text-xl font-semibold text-[rgb(var(--fg))]">
          {centro.codigo} · {centro.nombre}
        </h2>
        <p className="text-sm text-[rgb(var(--muted))]">{centro.activo ? 'Activo' : 'Inactivo'}</p>
      </header>

      <dl className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
        <DetailItem label="Empresa" value={centro.empresaId} />
        <DetailItem label="Centro padre" value={centro.padreLabel ?? 'Sin asignar'} />
        <DetailItem label="Creado" value={formatDateTime(centro.createdAt)} />
        <DetailItem label="Actualizado" value={formatDateTime(centro.updatedAt)} />
      </dl>
    </section>
  );
}

function DetailItem({ label, value }) {
  return (
    <div className="rounded-xl border border-[rgb(var(--border))] bg-[rgba(var(--subpanel),0.6)] px-4 py-3">
      <dt className="text-xs uppercase tracking-wide text-[rgb(var(--muted))]">{label}</dt>
      <dd className="mt-1 text-sm font-medium text-[rgb(var(--fg))]">{value ?? '-'}</dd>
    </div>
  );
}

function formatDateTime(value) {
  if (!value) return '-';
  try {
    const date = new Date(value);
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
  } catch (error) {
    return value;
  }
}
